export default "__VITE_ASSET__3d8e0c8e__"